// extracted by mini-css-extract-plugin
export default {"table":"TimeSlotSelector_table__ue2Rv","cell":"TimeSlotSelector_cell__hiQ-g","disabled":"TimeSlotSelector_disabled__usLLO","selected":"TimeSlotSelector_selected__1671C"};